(function () {
  window.Wishlist_API = {
    state: {
      wishlist_items: [],
      products_cache: [],
      initialized: false
    },

    swymStartCallback: function() {
      var self = this;

      window._swat.fetchWrtEventTypeET(function(r) {
        console.log('PREP WISHLIST ITEMS');
        if (window.buildWishlistPage) window.buildWishlistPage(r);

        self.state.wishlist_items = r.slice();
        self.state.initialized = true;
        self.updatePageBtns();
        document.dispatchEvent(new CustomEvent("wishlist:ready"));
      });
    },

    handleBtnClick: function(event) {
      if (document.body.classList.contains("template-collection") && !document.body.classList.contains("template-allow-wishlist")) return;

      event.preventDefault();

      
      var action = event.currentTarget.dataset.action;
      var productId = event.currentTarget.dataset.product;
      var product_cache = this.state.product_cache || window.Wishlist_API.state.products_cache;
      
      var product = product_cache.find(function(item) {
        if(item.id && item.id == productId) {
          return item.id == productId;
        } else if(item.product_id && item.product_id == productId) {
          return item.product_id && item.product_id == productId;
        }
      });

      if (!document.body.classList.contains("template-collection")) {
        var inventoryQty = product.variants.slice().reduce(function(total, variant) {
          return total + variant.inventory_quantity;
        }, 0);

        var variants = product.variants.slice().map(function(variant) {
          var obj = {};
          obj[variant.title] = variant.id;
          return obj;
        });
      }

      var variantId = (product.variants !== undefined && product.variants[0].id !== null) ? product.variants[0].id : product.skus[0].id;
      var currProductId = (product.id !== undefined && product.id !== null) ? product.id : product.product_id

      var wishlistProduct = {
        epi: parseInt(variantId),
        du: "https://jennifermeyer.com/products/" + product.handle,
        empi: parseInt(currProductId),
        et: 4
      };

      if (action === "add") {
        window._swat.addToWishList(wishlistProduct, function(r) {
          console.log("Added to wishlist", r);
          event.currentTarget.setAttribute("data-action", "remove");
          if (event.currentTarget.querySelector("span")) {
            event.currentTarget.querySelector("span").textContent = "Remove from Wishlist";
          }
          if (event.currentTarget.querySelector('.wishlist-icon')) {
            event.currentTarget.querySelector('.wishlist-icon').classList.add('in-list');
          }
        });
      } else {
        window._swat.removeFromWishList(wishlistProduct, function(r) {
          console.log("Removed from wishlist");
          event.currentTarget.setAttribute("data-action", "add");
          if (event.currentTarget.querySelector("span")) {
            event.currentTarget.querySelector("span").textContent = "Add To Wishlist";
          }

          if (event.currentTarget.querySelector('.wishlist-icon')) {
            event.currentTarget.querySelector('.wishlist-icon').classList.remove('in-list');
          }
        });
      }
    },

    updatePageBtns: function() {
      // console.log('Update On Page Items', this.state);

      var wishListItems = this.state.wishlist_items;

      wishListItems.slice().forEach(function(item) {
        var $btns = document.querySelectorAll(
          'button[data-product="' + item.empi + '"]'
        );

        [].forEach.call($btns, function($btn) {
          $btn.setAttribute("data-action", "remove");
          var span = $btn.querySelector("span");
          if (span) span.textContent = "Remove From Wishlist";
        });
      });

      $(".item-wishlist-add").on("click", this.handleBtnClick.bind(this));
    },

    gatherPageProduct: function() {
      try {
        var $scripts = document.querySelectorAll("script[product-source]");
        [].forEach.call($scripts, function($script) {
          var product = JSON.parse($script.innerHTML);
          console.log('product', product)
          window.Wishlist_API.state.products_cache.push(product);
        });
      } catch (error) {}
    },

    start: function() {
      var self = this;
      console.log("Start Wishlist");

      this.gatherPageProduct();

      if (!window.SwymCallbacks) {
        window.SwymCallbacks = [];
      }

      window.SwymCallbacks.push(function() {
        self.swymStartCallback();
      });
    }
  };

  window.Wishlist_API.start();
})();
